
import PageContainer from "./PageContainer";
import ContentSection from "./ContentSection";
import Header from "./header";
import LeftNav from "./leftnav";
import RightPane from "./rightpane";
import Pages from "./page";

export default {
	PageContainer,
	ContentSection,
	Header,
	LeftNav,
	RightPane,
	Pages,
};


/** WEBPACK FOOTER **
 ** ./src/scripts/components/index.js
 **/